
































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Container, Draggable } from 'vue-smooth-dnd';
import PropertyService from '@/services/properties';
import Property from '@/entities/Property';
import { Route } from 'vue-router';
import CarOption from '@/entities/CarOption';

@Component({
  components: {
    Container,
    Draggable,
  },
})
export default class Options extends Vue {
  propertyService = new PropertyService();

  properties: any = [];

  newProperty: any;

  makes: Property[];

  loading = false;

  orderChanged = false;

  saving: string = null;

  deleting: string = null;

  propertyTypes = [
    {
      title: 'Options',
      route: 'options',
    },
  ];

  get currentProperty() {
    return 'options';
  }

  mounted() {
    this.fetch(this.$route);

    this.propertyService.list('makes').then((makes) => {
      this.makes = makes;
    });
  }

  save(property: any) {
    if (!this.saving && !this.deleting) {
      this.saving = property.id;
      return this.propertyService
        .save(this.currentProperty, property)
        .finally(() => {
          this.saving = null;
        });
    }
    return null;
  }

  create() {
    this.saving = '';
    this.save(this.newProperty)
      .then((property: any) => {
        this.properties.push(property);
        this.freshNewProperty();
      })
      .finally(() => {
        this.saving = null;
      });
  }

  remove(property: any) {
    this.deleting = property.id;
    this.propertyService.delete(this.currentProperty, property)
      .then(() => {
        for (let n = 0; n < this.properties.length; n += 1) {
          if (this.properties[n].id === property.id) {
            this.properties.splice(n, 1);
            break;
          }
        }
      })
      .finally(() => {
        this.deleting = null;
      });
  }

  freshNewProperty() {
    if (this.currentProperty === 'option') {
      this.newProperty = new CarOption();
      return;
    }

    this.newProperty = new Property();
  }

  onDrop(dropResult: any) {
    const { removedIndex, addedIndex } = dropResult;
    if (removedIndex !== addedIndex) {
      this.orderChanged = true;
      for (let i = 0; i < this.properties.length; i += 1) {
        if (i === removedIndex) {
          this.properties[i].position = addedIndex + 1;
        } else if (removedIndex < addedIndex && i > removedIndex && i <= addedIndex) {
          this.properties[i].position -= 1;
        }
        if (removedIndex > addedIndex && i < removedIndex && i >= addedIndex) {
          this.properties[i].position += 1;
        }
      }

      this.properties = this.properties.sort((a: CarOption, b: CarOption) => a.position - b.position);
    }
  }

  saveOrder() {
    this.propertyService.saveOrder(this.properties)
      .then(() => {
        this.orderChanged = false;
      });
  }

  @Watch('$route', { immediate: true, deep: true })
  fetch(route: Route) {
    this.freshNewProperty();
    this.properties = [];

    if (this.currentProperty) {
      this.loading = true;
      this.propertyService.list(this.currentProperty)
        .then((properties) => {
          this.properties = properties;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
